export function getFileNameFromLink(link: string) {
  if(!link) return link;
  const splitedLink = link?.split("/")??[];
  const fileName = splitedLink[(splitedLink?.length??1) - 1]??' ';

  return fileName;
}
